import { useEffect, useState } from "react";
import { useWindowSize } from "react-use";
import HeaderLayout from "./header";
import s from "./index.module.scss";
import ListMenu from "./listMenu";
import Logo from "./logo";
import ProfileSideBar from "./profile";
// import useDarkModeJs from "../../common/customHook/useDarkMode.js";
import { Button, Modal } from "@mui/material";
import CustomerService from "modules/layout2/CustomerService";
import { useDispatch, useSelector } from "react-redux";
import { actionTypes as ticketTypes } from "../../redux/insertTicket";
import { actionTypes as loading } from "../../redux/loading";
import { actionTypes as notif } from "../../redux/notificationAlert";
import { motion } from "framer-motion";

const Layout2 = ({ children }) => {
  const [open, setopen] = useState(false);
  const dispatch = useDispatch();

  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");

  const { width, height } = useWindowSize();
  // useDarkModeJs()
  const handleClickOpen = () => {
    setopen((prev) => !prev);
  };
  useEffect(() => {
    if (open) {
      dispatch({ type: loading.loadingTrue, payload: {} });
      setTimeout(() => {
        dispatch({ type: loading.loadingFalse, payload: {} });
      }, 500);
    } else {
      dispatch({ type: loading.loadingTrue, payload: {} });
      setTimeout(() => {
        dispatch({ type: loading.loadingFalse, payload: {} });
      }, 500);
    }
  }, [open]);
  const [openModalTicker, setOpenModalTicket] = useState(false);

  const handleTicket = () => {
    dispatch({
      type: ticketTypes.insertTicketAsync,
      payload: { data: { content: content, title: title } },
    });
  };

  const reducerTable = useSelector((state) => state.insert_ticket_reducer);
  const isLoading = reducerTable?.loading;
  const isSuccess = reducerTable?.data?.is_successful;
  useEffect(() => {
    if (isSuccess) {
      setContent("");
      setTitle("");
      setOpenModalTicket(false);

      const successNotification = {
        type: notif.success,
        textAlert:
          "تیکت شما ثبت شد و در حال پیگیری است. نتیجه از طریق پیامک به اطلاع شما خواهد رسید.",
      };

      dispatch(successNotification);
      dispatch({ type: ticketTypes.insertTicketEMPTY });
    }
  }, [isSuccess]);

  return (
    <>
      <div className="flex h-full w-full relative bg-white  overflow-hidden ">
        <motion.div
          className={`flex flex-col items-center absolute top-0 right-0 lg:static shadow-xl 
    bg-white dark:bg-black justify-between ${
      width > 768 ? "tourguide-home-eighth-step" : null
    } 
    ${open ? s.fade : s.unfade}
  `}
          animate={{
            width: open ? (width > 768 ? 320 : 270) : width > 768 ? 70 : 0,
          }}
          transition={{
            duration: 0.25,
            ease: "easeInOut",
          }}
          style={{ overflowX: "hidden", overflowY: "auto" }}
        >
          <Logo open={open} handleClickOpen={handleClickOpen} />
          <div
            style={{ height: "calc(100vh - 120px)" }}
            className={`w-full flex flex-col items-center  overflow-x-hidden dark:bg-black  justify-between`}
          >
            <div className="flex flex-col overflow-hidden ">
              <ProfileSideBar open={open} />
              <ListMenu open={open} setopen={setopen} />
            </div>
            {/* <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div className={`w-full text-center`}>
                <CustomerService open={open} />
              </div>
              <hr />
              <div className={`w-full text-center`}>
                <div style={{ backgroundColor: "#099c55", margin: 2 }}>
                  {" "}
                  <Button
                    style={{ color: "white" }}
                    onClick={() => setOpenModalTicket(true)}
                    className="text-sm text-white"
                  >
                    ثبت تیکت
                  </Button>
                </div>
              </div>
            </div> */}
          </div>
        </motion.div>

        <span
          className={`inline md:hidden bg-[#F3F4F9] right-6 absolute ${
            width <= 768 && "tourguide-home-eighth-step"
          }`}
        >
          <Logo open={open} handleClickOpen={handleClickOpen} />
        </span>
        <div
          className={`bg-gray-50 w-full h-full overflow-y-auto  ${s.container}    `}
        >
          {open ? (
            <div
              className="absolute top-0 right-0 left-0 bottom-0 bg-gray-400 opacity-30 block lg:hidden"
              style={{ zIndex: 10000000, backgroundColor: "ButtonFace" }}
              onClick={() => setopen(false)}
            ></div>
          ) : (
            ""
          )}
          <HeaderLayout open={open} />
          <div className="w-full h-full  bg-[#f5f6fb] pb-8 md:pr-20 lg:pr-8 px-3 lg:pl-8 ">
            {children}
          </div>
        </div>
      </div>
      <Modal
        // hideBackdrop
        open={openModalTicker}
        onClose={() => {
          setOpenModalTicket(false);
        }}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <div
          style={{
            display: "flex",
            minHeight: 350,
            backgroundColor: "#ffffff",
            zIndex: 100,

            borderRadius: 5,
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            outline: 0,
            border: 0,
            boxShadow: 24,
          }}
        >
          <div className=" w-full p-4">
            <div className="w-full   gap-4  p-4 ">
              <p className="text-lg text-center">ثبت تیکت</p>
              <div className="p-6 gap-4 w-full">
                <div>
                  <span>موضوع</span>
                  <input
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    className="h-12 p-4 w-full border mt-2"
                  />
                </div>
                <div className="mt-6">
                  <span>توضیحات </span>
                  <textarea
                    value={content}
                    onChange={(e) => setContent(e.target.value)}
                    rows={4}
                    type=""
                    className="h-36  w-full border mt-2 p-4 max-h-28"
                  />{" "}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Button
                  style={{ marginInlineEnd: 16 }}
                  variant="contained"
                  color="primary"
                  size="large"
                  className="text-white md:max-w-[250px]  mt-8"
                  onClick={() => {
                    if (!(title || content || isLoading)) {
                      return;
                    }
                    handleTicket();
                  }}
                  disabled={!title || !content || !!isLoading}
                >
                  ثبت{" "}
                </Button>
                <Button
                  variant="contained"
                  color="inherit"
                  size="large"
                  className="text-white md:max-w-[250px]  mt-8"
                  onClick={() => {
                    setOpenModalTicket(false);
                    setContent("");
                    setTitle("");
                  }}
                >
                  انصراف{" "}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Layout2;
